module.exports = __webpack_public_path__ + "img/scalable-dark.a4f05d8e.png";